import React from "react";
import withCustomComponent from "providers/withCustomComponent";
import { compose } from "redux";
import BaseCommissionsSubsidiesComponent from "./BaseCommissionsSubsidiesComponent";

const CommissionsComponent = props => <BaseCommissionsSubsidiesComponent {...props} />;

CommissionsComponent.defaultProps = {
  isSubsidy: false
};

CommissionsComponent.propTypes = {};

export default compose(withCustomComponent("CommissionsComponent"))(CommissionsComponent);
